import { cubicBezier } from 'motion'

/**
 * Easing equation function for a cubic (t^3) easing in: accelerating from zero velocity.
 */
export function easeInOutCubicFn(x: number) {
  return x < 0.5 ? 4 * x * x * x : 1 - (-2 * x + 2) ** 3 / 2
}

export function easeOutCubic() {
  return cubicBezier(0.33, 1, 0.68, 1)
}
